module.exports = __webpack_public_path__ + "img/logo-inprocal.8bf961c3.png";